import React, { PropsWithChildren } from 'react';
import { CalendarContext } from './context';
import useUser from '../../hooks/global/useUser';
import useCalendarSocket from '../../hooks/calendar/useCalendarSocket';
import { LoadedUser } from '../../interfaces';
import {
  getInitialArtistOptions,
  getInitialSelectedArtists,
} from '../../helpers/employees';
import { FILTER_PERSISTENCE_KEYS } from '../../constants/global';

const ARTIST_FILTER_NAME = FILTER_PERSISTENCE_KEYS.calendarArtists;

export function CalendarProvider({ children }: PropsWithChildren) {
  const { user: loadedUser } = useUser<LoadedUser>();

  const [selectedCalendarArtists, setSelectedCalendarArtists] = React.useState<
    string[]
  >(() => {
    if (!loadedUser) return [];
    return getInitialSelectedArtists(
      loadedUser,
      getInitialArtistOptions(loadedUser),
      ARTIST_FILTER_NAME,
    );
  });

  useCalendarSocket(selectedCalendarArtists);

  const contextValue = React.useMemo(
    () => ({
      selectedCalendarArtists,
      setSelectedCalendarArtists,
    }),
    [selectedCalendarArtists],
  );

  return (
    <CalendarContext.Provider value={contextValue}>
      {children}
    </CalendarContext.Provider>
  );
}
